<template>
  <div id="app" style="overflow: hidden;">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
  font-family:"思源黑体","Microsoft YaHei";
}
/* a {
  text-decoration: none;
  display: block;
  color: #fff;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #fff;
  border-width: 1px 1px 0 0;
  background: #255f9e;
}
ul,li{
  list-style: none;
  padding: 0;
  margin: 0;
} */
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 1.5vh;
}
.home_container__Myqoy{
  width: 100%;
  height: 100%;
}
.el-range-editor .el-range-input{
  background: rgba(0,0,0,0);
  color: #ffffff!important;
}
.el-date-editor .el-range__icon{
  color: #0099E6 !important;
  /* margin-bottom: 4%; */
  line-height: 24px !important;
}
.el-date-editor .el-range__close-icon{
  color: #ffffff!important;
  line-height: 24px !important;
  /* margin-bottom: 4%; */
}
.el-date-editor .el-range-separator{
  color: #ffffff!important;
  /* margin-bottom: 4%!important; */
  line-height:24px !important;
}
.el-radio{
  color: #ffffff!important;
}

/* 下拉框设置-开始 */
.el-select-dropdown__list {
  display: flex;
    flex-direction: column;
}
@font-face {
  font-family: "HarmonyOS Sans SC";
  src: url(@/launcher/HarmonyOS_Sans_SC.ttf);
}
.el-select-dropdown__item {
    font-size: 1.3vh !important;
       font-family: 'HarmonyOS Sans SC';
    padding: 0 !important;
    position: relative;
    white-space: nowrap;
    width: 100%!important;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #ebeef5!important;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
}
.el-select .el-input__inner {
  width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  /* height: 100%; */
  font-size: 1.3vh;
}
.el-select{
  /* width: 25%;
  height: 80%; */
  /* position: absolute!important;
  top: 0%;
  right: 0%; */
}

.el-select:hover .el-input__inner {
  /* border-color: transparent!important;
  background: transparent!important; */
  color: #fff!important;
  padding-right: 5px!important;
  padding-left: 5px!important;
}
.el-input__inner {
  border-color: transparent!important;
  background: transparent!important;
  color: #fff!important;
  height: 30px !important;
  padding-right: 5px!important;
  padding-left: 5px!important;
}
.el-input {
  position: relative;
  font-size: 14px!important;
  height: 100%;
}
.el-select .el-input .el-select__caret{
  display: flex;
  align-items: center;
  color: #32A5F5;
}
.el-select-dropdown{
    background: #0c1225 !important;
    color: #fff !important;
    border: 1px solid #3a8ee6 !important;
 }
 .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
  background-color: #3a8ee6 !important;
 }
/* 下拉框设置-结束 */

/* 日期选择器组件设置-开始 */
.el-picker-panel{
    background: #fff !important;
    color: #070707 !important;
    /* left: 1070px !important; */
    left: 65.7% !important;
}
.el-date-range-picker{
    width: 618px !important;
}
.el-picker-panel__footer{
    background-color: #060d55 !important;
}
.popper__arrow{
  left: 69% !important;
}
.el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div{
  background-color: #3a8ee6 !important;
}
/* 日期选择器组件设置-结束 */
</style>
